'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _episodevalue = require('./episodevalue.component');

var _episodevalue2 = _interopRequireDefault(_episodevalue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var episodevalueModule = _angular2.default.module('episodevalue', [_angularUiRouter2.default]).component('episodevalue', _episodevalue2.default);

exports.default = episodevalueModule;


// WEBPACK FOOTER //
// ./client/app/common/admin/episodevalue/episodevalue.js